import type {PartCodeList, PartLinkedAgent} from 'schemaDefinition/types';

export const getPartCodelistFromLinkedAgent = (
  partLinkedAgent: PartLinkedAgent,
): PartCodeList | undefined => {
  if (!partLinkedAgent.roleCodelistId) {
    return undefined;
  }

  return {
    type: 'codelist',
    name: 'roles',
    codelistId: partLinkedAgent.roleCodelistId,
    required: true,
    cardinality: 'multiple',
  };
};
